import { LOGIN_SUCCESS, REGISTER_SUCCESS, SET_UBER_TOKEN } from '../constants/ActionTypes';

export default function auth(state = {}, action) {
    switch (action.type) {
        case LOGIN_SUCCESS:
        case REGISTER_SUCCESS: {
            const { uberToken } = action;
            return { ...state, uberToken };
        }
        case SET_UBER_TOKEN:
            return { ...state, isAuthenticated: true };
        default:
            return state;
    }
}
